import EnergyHeader from "../../components/energy/energyHeader";
import SideBar from "../../components/UserDashboard/SideBar";
import "../../styles/UserDashboard/ViewDispute.scss";

export default function ViewDispute() {
  return (
   <>
    <div className="view-dispute">
         <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="view-dispute__inner">
   <EnergyHeader />
        <div className="view-dispute__inner__back">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.0004 10.9987H7.83041L12.7104 6.11869C13.1004 5.72869 13.1004 5.08869 12.7104 4.69869C12.6179 4.60599 12.508 4.53244 12.387 4.48226C12.2661 4.43208 12.1364 4.40625 12.0054 4.40625C11.8744 4.40625 11.7448 4.43208 11.6238 4.48226C11.5028 4.53244 11.3929 4.60599 11.3004 4.69869L4.71041 11.2887C4.61771 11.3812 4.54416 11.4911 4.49398 11.6121C4.4438 11.733 4.41797 11.8627 4.41797 11.9937C4.41797 12.1247 4.4438 12.2543 4.49398 12.3753C4.54416 12.4963 4.61771 12.6062 4.71041 12.6987L11.3004 19.2887C11.393 19.3813 11.5029 19.4547 11.6239 19.5048C11.7448 19.5549 11.8745 19.5807 12.0054 19.5807C12.1363 19.5807 12.266 19.5549 12.387 19.5048C12.5079 19.4547 12.6178 19.3813 12.7104 19.2887C12.803 19.1961 12.8764 19.0862 12.9265 18.9652C12.9766 18.8443 13.0024 18.7146 13.0024 18.5837C13.0024 18.4528 12.9766 18.3231 12.9265 18.2022C12.8764 18.0812 12.803 17.9713 12.7104 17.8787L7.83041 12.9987H19.0004C19.5504 12.9987 20.0004 12.5487 20.0004 11.9987C20.0004 11.4487 19.5504 10.9987 19.0004 10.9987Z" fill="black"/>
</svg>
Back
            </div>
        <div className="view-dispute__inner__card">

        <label htmlFor="">Transaction ID</label>
          <input type="text" placeholder="ND-19UTOSZ" />
          <label htmlFor="">Issue Type</label>
          <input type="text" placeholder="Enter the subject" />
          <label htmlFor="">Description</label>
          <textarea
            name=""
            id=""
            placeholder="Give a detailed explanation of the issue"
          ></textarea>
          <label htmlFor="">Uploaded Image</label>
        </div>

      </div>
    </div>
   </>
  );
}
